import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants'
import { oneAssetApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class FundListService {

  private _fundListUrl: string = oneAssetApi + "/Fund/GetList";
  private _body: object = { FundTypeId: "", FundCode: "" };

  constructor(private http: HttpClient) { }

  getFundList() {
    return this.http.post(this._fundListUrl, this._body);
  }


  getFundList_2() {
    let URL = cmsApi + '/FundOnWeb';
    let body = {};
    return this.http.post(URL, body);
  }



}
